import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'arrow-alt-circle-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCircleDown" */
        '@fortawesome/free-regular-svg-icons/faCircleDown'
    ),
    'circle-stop': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faStopCircle" */
        '@fortawesome/free-regular-svg-icons/faStopCircle'
    ),
    'face-kiss-wink-heart': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faKissWinkHeart" */
        '@fortawesome/free-regular-svg-icons/faKissWinkHeart'
    ),
    'face-laugh-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faLaughWink" */
        '@fortawesome/free-regular-svg-icons/faLaughWink'
    ),
    'file-word': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFileWord" */
        '@fortawesome/free-regular-svg-icons/faFileWord'
    ),
    'flushed': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFlushed" */
        '@fortawesome/free-regular-svg-icons/faFlushed'
    ),
    'font-awesome-logo-full': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFontAwesomeLogoFull" */
        '@fortawesome/free-regular-svg-icons/faFontAwesomeLogoFull'
    ),
    'grin-tongue-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinTongueWink" */
        '@fortawesome/free-regular-svg-icons/faGrinTongueWink'
    ),
    'hand-paper': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHandPaper" */
        '@fortawesome/free-regular-svg-icons/faHandPaper'
    ),
    'hard-drive': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHdd" */
        '@fortawesome/free-regular-svg-icons/faHdd'
    ),
    'hourglass-empty': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHourglassEmpty" */
        '@fortawesome/free-regular-svg-icons/faHourglassEmpty'
    ),
    'laugh-squint': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faLaughSquint" */
        '@fortawesome/free-regular-svg-icons/faLaughSquint'
    ),
    'question-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faQuestionCircle" */
        '@fortawesome/free-regular-svg-icons/faQuestionCircle'
    ),
    'rectangle-times': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faWindowClose" */
        '@fortawesome/free-regular-svg-icons/faWindowClose'
    ),
    'smile-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSmileWink" */
        '@fortawesome/free-regular-svg-icons/faSmileWink'
    ),
    'square-caret-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSquareCaretDown" */
        '@fortawesome/free-regular-svg-icons/faSquareCaretDown'
    ),
    'sun': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSun" */
        '@fortawesome/free-regular-svg-icons/faSun'
    ),
    'thumbs-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faThumbsDown" */
        '@fortawesome/free-regular-svg-icons/faThumbsDown'
    ),
    'user': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faUser" */
        '@fortawesome/free-regular-svg-icons/faUser'
    ),
    'window-minimize': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faWindowMinimize" */
        '@fortawesome/free-regular-svg-icons/faWindowMinimize'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>